import React from "react";
import classNames from "classnames";
import useElevenLabs from './hooks/useElevenLabs'

const EvenLabs = () => {
  const {
    elevenLabsClient,
    conversationId,
    isSpeaking,
    handleStartConversation,
    handleEndSession,
  } = useElevenLabs();

  return (
    <div className="flex gap-3">
      <div>
        <button
          className={classNames("bg-shaiaBlue text-DarkBlue-500 p-4", {
            "bg-shaiaOrange": conversationId,
          })}
          onClick={handleStartConversation}
          disabled={!elevenLabsClient || isSpeaking}
        >
          Start Conversation
        </button>
      </div>
      <div>
        <button
          className={classNames("bg-shaiaBlue text-DarkBlue-500 p-4", {
            "bg-shaiaOrange": conversationId,
          })}
          onClick={handleEndSession}
          disabled={!elevenLabsClient || isSpeaking}
        >
          Stop Conversation
        </button>
      </div>
    </div>
  );
};

export default EvenLabs;
